<template>
  <WsMain>
    <WsCrud
      ref="WsCrud"
      :modelName="modelName"
      label="請假覆核"
      :fields="$store.state.model[modelName].fields"
      :liveSearching="true"
      :showFields="showFields"
      :order="order"
      :plusOrderItems="plusOrderItems"
      :filterSelects="filterSelects"
      :infiniteScroll="true"
      :creatable="true"
      :deletable="true"
      :inRowBtnDelete="true"
      :inRowBtnUpdate="false"
      :updatable="false"
      :customTableActions="customTableActions"
      @check="$_onCheck($event)"
      @uncheck="$_onUncheck($event)"
    ></WsCrud>
    <WsReviewDialog ref="WsReviewDialog"></WsReviewDialog>
  </WsMain>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "請假覆核",
    };
  },

  data: () => ({
    customTableActions: [
      {
        emit: "check",
        icon: "done",
      },
      {
        emit: "uncheck",
        icon: "close",
      },
    ],
    order: "last_leave",
    modelName: "leave_day",
    showFields: ["id", "start_date", "days", "wasa", "status"],
    plusOrderItems: [
      {
        value: "last_leave",
        text: "最近請假",
        order_by: "start_date",
        order_way: "desc",
      },
    ],
    filterSelects: {
      status: {
        label: "狀態",
        items: [
          {
            text: "全部",
            value: "all",
            params: {},
          },
          {
            value: 0,
            text: "申請中",
            params: {
              status: 0,
            },
          },
          {
            value: 1,
            text: "OK",
            params: {
              status: 1,
            },
          },
          {
            value: 2,
            text: "打妹",
            params: {
              status: 2,
            },
          },
        ],
      },
    },
    statusItems: [
      {
        value: 1,
        text: "OK",
      },
      {
        value: 2,
        text: "打妹",
      },
    ],
  }),

  methods: {
    async $_onCheck($event) {
      const tarId = $event.item.id;
      await this.$axios.patch(`${this.modelName}/${tarId}`, {
        status: 1,
      });
      this.$refs.WsCrud.reset();
      this.$refs.WsCrud.fetchData();
    },
    async $_onUncheck($event) {
      const tarId = $event.item.id;
      await this.$axios.patch(`${this.modelName}/${tarId}`, {
        status: 2,
      });
      this.$refs.WsCrud.reset();
      this.$refs.WsCrud.fetchData();
    },
  },
};
</script>